require('./_report-sku');
require('../../landing/search/_sku-clickable');
require('../../search/_submit');
const StreamedEvents = require('./StreamedEvents');

jQuery(document).ready(() => {
  let currentBtn = null;
  const pendingTitleStreamingEventsEl = $('#editPendingItemModal select[name=streamed_events]');
  const pendingTitleRecordingOptionsEl = $('#editPendingItemModal select[name=recording_option]');

  localStorage.setItem('lastSelectedReprint', idReprint);
  localStorage.setItem('lastSelectedWeek', dateReport);

  $('#available-lists').select2({
    placeholder: __('Select a list to report from'),
    minimumResultsForSearch: Infinity
  });

  $('.select-title').select2({
    placeholder: __('Select title to report'),
    minimumResultsForSearch: Infinity
  });

  $('.select-template').select2({
    placeholder: __('Select List'),
    minimumResultsForSearch: Infinity
  });

  $('.select-template').select2({
    placeholder: __('Select List'),
    minimumResultsForSearch: Infinity
  });

  $('.select-reportForWeek').select2({
    placeholder: __('Select Week'),
    minimumResultsForSearch: Infinity
  });

  $('#save-successfull button.close, #save-error button.close').click(function () {
    $(this).parent().hide();
  });

  $('#addToListForm').submit((e) => {
    e.preventDefault();
  });

  $('#submit-view').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    const dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        /* redirect to url from response */
        window.location.href = `${redirectToListUrl}?id=${data.idList}`;
      }
    });
  });

  $('#submit-continue').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    const dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        toastr.success(__('List has been saved successfully.'));
        $('#addToListModal').modal('hide');
      }
    });
  });

  $('#addToListModal').on('show.bs.modal', (e) => {
    $('#addToListAlert').hide();

    $('.select-template').select2('val', '');
    $('#addToListModal input[name="list-name"]').val('');
  });

  $('#QrtLists').submit(function (e) {
    const form = $(this);
    const dataArr = form.serializeJson();
    const btn = form.find('button');

    btn.loading();

    $.post(reportFromListUrl, {
      dataArr
    }).done(() => {
      location.reload();
    }).always(() => {
      btn.loading('reset');
    });

    e.preventDefault();
  });

  $('.add-title-to-report').click(function (e) {
    const btnRfc = $(this);
    const idTitle = $(this).parent().parent().find('select')
        .val();

    btnRfc.loading();

    $.post(reportSingleTitleUrl, {
      idRegistration,
      idTitle
    }).done(() => {
      location.reload();
    }).always(() => {
      btnRfc.loading('reset');
    });

    e.preventDefault();
  });

  $('#removeTitleModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);
  });

  $('#btnRemoveItem').click(function () {
    const btn = $(this);

    btn.loading();
    $.post(removeTitleUrl, {
      idTitle: currentBtn.data('id-title'),
      idHymn: currentBtn.data('id-hymn'),
      idRegistration: currentBtn.data('id-registration')
    }, (data) => {
      btn.loading('reset');
      if (data.isError == 1) {
        toastr.error(data.msgError);
      } else {
        currentBtn.closest('.search-music').slideToggle(300, function () {
          $(this).remove();

          if (!$('.panel-report .row-title').length) {
            $('.missing-titles-info').fadeIn();
          }
        });

        currentBtn = null;

        $('#removeTitleModal').modal('hide');
      }
    }, 'json');
  });

  $('.panel-report .select-reportForWeek').change(function () {
    const value = $(this).val();
    window.location.href = redirectReportsManage + value;
  });

  $('#process-download, .download-single-song').click(function (e) {
    document.cookie = 'fileDownload=; Max-Age=0';
    const urlFile = $(this).data('url');

    if (urlFile != null) {
      $('#downloadAllModal #navigation').hide();
      $('#downloadAllModal #loading').show();
      $('#downloadAllModal').modal('show');

      $.get(urlFile, (data) => {
        if (data.isError === 1) {
          $('#downloadAllModal').modal('hide');
          toastr.error(data.msgError, 'Error');
        } else {
          $('#downloadAllModal #navigation').show();
          $('#downloadAllModal #loading').hide();
        }
      }, 'json');
    }

    e.preventDefault();
  });

  pendingTitleStreamingEventsEl.select2nonUnique({
    placeholder: 'Streaming Events',
    minimumResultsForSearch: Infinity
  });

  pendingTitleRecordingOptionsEl.select2nonUnique({
    placeholder: 'Reocording Option',
    minimumResultsForSearch: Infinity
  });

  $('#editPendingItemModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);

    const master = currentBtn.data('master');
    const reprint = currentBtn.data('reprint');

    StreamedEvents.toggleServicesElements(
      reprint,
      master,
      pendingTitleStreamingEventsEl,
      pendingTitleRecordingOptionsEl
    );

    $('#editPendingItemModal #p-title').html(`"${currentBtn.data('title')}"`);
    $('#editPendingItemModal select[name="streamed_events"]').val(currentBtn.data('reprint-num-services')).trigger('change');
    $('#editPendingItemModal select[name="recording_option"]').val(currentBtn.data('recording-option')).trigger('change');
  });

  $('#submitEditPendingForm').click((e) => {
    e.preventDefault();

    $('#editPendingItemModalAlert').hide();

    const streamedEvents = $('#reportPendingFormEdit select[name="streamed_events"]').val();
    const recordingOption = $('#reportPendingFormEdit select[name="recording_option"]').val();

    $('#editPendingItemModal').find('button').button('loading');

    $.post(savePendingTrackUrl, {
      id: currentBtn.data('id-submission'),
      streamedEvents,
      recordingOption
    }, (data) => {
      $('#editPendingItemModal').modal('hide');

      StreamedEvents.updateLabels(currentBtn, streamedEvents, recordingOption);
    }).always(() => {
      $('#editPendingItemModal').find('button').button('reset');
    });
  });

  $('#removePendingSongModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);
  });

  $('#btnRemovePendingSong').click(() => {
    $('#removePendingSongModal').find('button').button('loading');

    $.post(removePendingSongUrl, {
      id: currentBtn.data('id-submission')
    }, (data) => {
      $('#removePendingSongModal').find('button').button('reset');

      if (data.isError == 1) {
        toastr.error(data.msgError);
      } else {
        currentBtn.parent().parent().parent().fadeOut(300, function () {
          const parent = $(this).parent();

          $(this).remove();

          if (parent.find('.search-music').length == 0) {
            parent.html(`<i>${__('No pending tracks to display')}</i>`);
          }
        });

        currentBtn = null;

        $('#removePendingSongModal').modal('hide');
      }
    }, 'json');
  });

  $('#removeAllSongs').click(function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    bootbox.confirm({
      title: __('Delete All Reported Songs'),
      message: __('Are you sure you want to delete all reported songs from this week?'),
      buttons: {
        cancel: {
          label: `<i class="fa fa-times"></i> ${__('No')}`,
          className: 'btn btn-light-purple'
        },
        confirm: {
          label: `<i class="fa fa-check"></i> ${__('Yes')}`,
          className: 'btn btn-danger'
        }
      },
      callback(result) {
        const submitBtn = $('.bootbox-confirm .modal-footer button.btn-space');
        const cancelBtn = $('.bootbox-confirm .modal-footer button.btn-dark');
        cancelBtn.prop('disabled', true);
        submitBtn.button('loading');

        if (result) {
          $.post(removeAllReportedSongsUrl, {
            id
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(__('Songs has been removed.'), __('Success'));
              location.reload();
            }

            cancelBtn.prop('disabled', false);
            submitBtn.button('reset');
            btn.button('reset');
          });
        } else {
          cancelBtn.prop('disabled', false);
          submitBtn.button('reset');
          btn.button('reset');
          return true;
        }

        return false;
      }
    });

    e.preventDefault();
  });

  function changePendingTitleStreamingEvents() {
    ensureNotZeroNumServices($(this), pendingTitleRecordingOptionsEl);
  }

  function changePendingTitlePdocastNumServices() {
    ensureNotZeroNumServices($(this), pendingTitleStreamingEventsEl);
  }

  function ensureNotZeroNumServices(currentEl, otherEl) {
    if (parseInt(currentEl.val()) === 0 && parseInt(otherEl.val()) === 0) {
      otherEl.val(1).change();
    }
  }

  function servicesLabelClicked() {
    $(this).parent().parent().find('.edit-report')
        .click();
  }

  pendingTitleRecordingOptionsEl.change(changePendingTitlePdocastNumServices).change();
  pendingTitleStreamingEventsEl.change(changePendingTitleStreamingEvents).change();

  $('.info_num_services').click(servicesLabelClicked);
});
